<template>
    <transition :name="transitionName">
        <div class="main-container">
            <router-view class="child-view"></router-view>
        </div>
    </transition>
</template>
<script>
    export default {
        data() {
            return {
                transitionName: 'slide-left'
            }
        },
        beforeRouteUpdate (to, from, next) {
            let isBack = this.$router.isBack
            // console.log(isBack);
            if (isBack) {
                this.transitionName = 'slide-right'
            } else {
                this.transitionName = 'slide-left'
            }
            this.$router.isBack = false
            next()
        },
        components: {},
        methods: {}
    }
</script>
<style lang="stylus" rel="stylesheet/stylus">
    @import "../common/stylus/variable.styl"
    .child-view
        width 100%
        transition all .8s cubic-bezier(.55,0,.1,1)
        overflow-y scroll
        -webkit-overflow-scrolling touch

    .main-container
        height 100%
        position relative
        overflow-y scroll

    .top-bar
        height 1.12rem
        background-color #fff
        padding 0 .28rem
        display flex
        align-items center
        justify-content space-between
        box-shadow 2px 1px 5px 0 rgba(164,164,164,0.50)
        .logo-con
            display flex
            align-items center
            .logo
                width .8rem
                height .8rem
                border-radius 2px
            .name
                font-size $font-size-large
                color $color-theme
                margin-left .2rem
        .btn
            width 1.96rem
            height .66rem
            line-height .66rem
            text-align center
            color $color-theme
            font-size $font-size-medium
            border .5px solid $color-theme
            border-radius .08rem
    .bottom-bar
        height 1rem
        background-color #fff
        position fixed
        bottom 0
        left 0
        width 100%

    .ibox
        background-color #fff
        box-shadow 0 2px 4px 0 rgba(229,229,229,0.50)
        margin-bottom .12rem
        .ibox-title
            height 1rem
            border-bottom .5px solid #dfdfdf
            display flex
            align-items center
            justify-content space-between
            padding-right .28rem
            h5
                padding-left .28rem
                border-left 4px solid #d3b62d
                color #333
                font-size $font-size-medium-x
            .more
                color #9d9d9d
                font-size $font-size-medium
        .ibox-content
            padding .28rem
            font-size $font-size-medium
            color #333
            line-height 1.5
            img
                width 100%
                margin .28rem 0
            iframe
                width 100% !important
            video
                width 100% !important
            b
                font-weight 900 !important
</style>




// WEBPACK FOOTER //
// src/pages/Index.vue